import "./DynamicFieldRenderer.css";

const getOptionLabel = (option) => option.label || option.value;

export default function DynamicFieldRenderer({
  field,
  value,
  onChange,
  error,
  disabled = false,
}) {
  const id = `field-${field.key}`;

  const options = field.options || [];

  const useOptionCards =
    ["select", "radio"].includes(field.type) &&
    options.length > 0 &&
    options.length <= 4;

  const handleInputChange = (event) => {
    onChange(field.key, event.target.value);
  };

  const handleBooleanChange = (nextValue) => {
    onChange(field.key, nextValue);
  };

  const handleMultiSelectChange = (event) => {
    const selectedValues = Array.from(event.target.selectedOptions).map(
      (option) => option.value,
    );

    onChange(field.key, selectedValues);
  };

  return (
    <div className={`dynamic-field dynamic-field--${field.width || "full"}`}>
      <label htmlFor={id}>
        <span>{field.label}</span>
        {field.required && <small>*</small>}
      </label>

      {field.type === "textarea" && (
        <textarea
          id={id}
          name={field.key}
          value={value || ""}
          onChange={handleInputChange}
          placeholder={field.placeholder || ""}
          disabled={disabled}
          className={error ? "dynamic-field__input--error" : ""}
        />
      )}

      {["text", "email", "number", "date"].includes(field.type) && (
        <input
          id={id}
          name={field.key}
          type={field.type}
          value={value || ""}
          onChange={handleInputChange}
          placeholder={field.placeholder || ""}
          disabled={disabled}
          className={error ? "dynamic-field__input--error" : ""}
        />
      )}

      {field.type === "select" && useOptionCards && (
        <div className="dynamic-field__choice-grid">
          {options.map((option) => (
            <button
              key={option.value}
              type="button"
              disabled={disabled}
              className={`dynamic-field__choice ${
                value === option.value ? "dynamic-field__choice--active" : ""
              }`}
              onClick={() => onChange(field.key, option.value)}
            >
              {getOptionLabel(option)}
            </button>
          ))}
        </div>
      )}

      {field.type === "select" && !useOptionCards && (
        <select
          id={id}
          name={field.key}
          value={value || ""}
          onChange={handleInputChange}
          disabled={disabled}
          className={error ? "dynamic-field__input--error" : ""}
        >
          <option value="">Selecteer...</option>

          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {getOptionLabel(option)}
            </option>
          ))}
        </select>
      )}

      {field.type === "radio" && (
        <div className="dynamic-field__choice-grid">
          {options.map((option) => (
            <button
              key={option.value}
              type="button"
              disabled={disabled}
              className={`dynamic-field__choice ${
                value === option.value ? "dynamic-field__choice--active" : ""
              }`}
              onClick={() => onChange(field.key, option.value)}
            >
              {getOptionLabel(option)}
            </button>
          ))}
        </div>
      )}

      {field.type === "multiselect" && (
        <select
          id={id}
          name={field.key}
          multiple
          value={Array.isArray(value) ? value : []}
          onChange={handleMultiSelectChange}
          disabled={disabled}
          className={error ? "dynamic-field__input--error" : ""}
        >
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {getOptionLabel(option)}
            </option>
          ))}
        </select>
      )}

      {(field.type === "checkbox" || field.type === "boolean") && (
        <div className="dynamic-field__boolean">
          <button
            type="button"
            disabled={disabled}
            className={value === true ? "dynamic-field__boolean--active" : ""}
            onClick={() => handleBooleanChange(true)}
          >
            Ja
          </button>

          <button
            type="button"
            disabled={disabled}
            className={value === false ? "dynamic-field__boolean--active" : ""}
            onClick={() => handleBooleanChange(false)}
          >
            Nee
          </button>
        </div>
      )}

      {![
        "text",
        "textarea",
        "email",
        "number",
        "date",
        "select",
        "radio",
        "multiselect",
        "checkbox",
        "boolean",
      ].includes(field.type) && (
        <div className="dynamic-field__unsupported">
          Veldtype wordt nog niet ondersteund: {field.type}
        </div>
      )}

      {field.help_text && <p>{field.help_text}</p>}

      {error && <strong className="dynamic-field__error">{error}</strong>}

      {disabled && (
        <span className="dynamic-field__readonly">Alleen lezen</span>
      )}
    </div>
  );
}
